import React from "react";
import { useParams } from "react-router-dom";
import QuantoValeCasaMia from "./QuantoValeCasaMia";

/**
 * Wrapper per le route per-città: /quanto-vale-casa-mia/:citta
 * Estrae il param, lo normalizza (capitalize) e lo passa come presetCity
 * al componente base. La pagina renderizza title + meta + H1 + JSON-LD
 * specifici per quella città → Google la indicizza come pagina dedicata.
 */
const SUPPORTED_CITIES = new Set([
  "milano","roma","torino","bergamo","bologna","firenze","napoli","genova",
  "brescia","verona","padova","bari","palermo","catania","cagliari","trieste",
  "venezia","modena","parma","reggio-emilia","perugia","ancona","pescara",
  "lecce","como","monza","varese","udine","trento","bolzano","sassari",
]);

function capitalize(s) {
  return s.split(/[-\s]/).map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
}

export default function QuantoValeCasaMiaCity() {
  const { citta } = useParams();
  const slug = (citta || "").toLowerCase();
  if (!SUPPORTED_CITIES.has(slug)) {
    // 404 soft: rimanda alla landing principale
    return <QuantoValeCasaMia />;
  }
  return <QuantoValeCasaMia presetCity={capitalize(slug)} />;
}
